import { render } from "./manage-dependents-modal.vue?vue&type=template&id=201f2200"
import script from "./manage-dependents-modal.vue?vue&type=script&lang=js"
export * from "./manage-dependents-modal.vue?vue&type=script&lang=js"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__